<template>
	<div class="course_wrap">
		<div class="course_admin">
			<header>
				<div class="goback" @click="goBack">
					<img src="../../../../static/images/course/icon-3.png"/>
					<span>返回</span>
				</div>
				<i></i>
				<span>{{$route.query.courseName}}</span>
			</header>
			<div class="tabs">
				<el-tabs v-model="$store.state.activeName" @tab-click="handleClick">
			    <el-tab-pane label="教学班" name="first">
			    	<teachclass ref="teachclass" v-if="$store.state.activeName == 'first'"></teachclass>
			    </el-tab-pane>
			    <el-tab-pane label="课程预览" name="second">
            <course-content v-if="$store.state.activeName == 'second'"></course-content>
          </el-tab-pane>
			    <el-tab-pane label="课程考核" name="third" v-if="productFlag==1">
			    	<courseassessment v-if="$store.state.activeName == 'third'" ref="courseassessment"></courseassessment>
			    </el-tab-pane>
			    <el-tab-pane label="课程考试" name="fourth" v-if="productFlag==1">
			    	<coursetest v-if="$store.state.activeName == 'fourth'"></coursetest>
			    </el-tab-pane>
			    <el-tab-pane label="讨论答疑" name="fifth">
			    	<discussanswer v-if="$store.state.activeName == 'fifth'"></discussanswer>
			    </el-tab-pane>
			    <el-tab-pane label="课程通知" name="sixth">
			    	<coursenotice ref="coursenotice" v-if="$store.state.activeName == 'sixth'"></coursenotice>
			    </el-tab-pane>
			  </el-tabs>
			</div>
		</div>
  </div>
</template>

<script>
	import teachclass from "./components/teachClass.vue"
	import coursenotice from "./components/courseNotice.vue"
	import discussanswer from "./components/discussAnswer.vue"
	import courseinformation from "./components/courseInformation.vue"
	import courseassessment from "./components/courseAssessment.vue"
  import coursetest from "./components/courseTest.vue"
  import courseContent from './components/courseContent.vue'
	export default {
		data(){
			return {
				activeName: this.$store.state.activeName,
				backShow:true,
				productFlag: sessionStorage.getItem('productFlag')
			}
		},
		components:{
			teachclass,
			coursenotice,
			discussanswer,
			courseinformation,
			courseassessment,
      coursetest,
      courseContent
		},
		created(){
      if(this.$store.state.activeName == 'fifth'){
        this.$store.state.activeName = 'fifth'
      }else if(this.$store.state.activeName == 'second'){
        this.$store.state.activeName = 'second'
      }
		},
		methods:{
			goBack(){
				this.$store.state.activeIndex = this.$route.query.activeIndex;
        if(this.productFlag==1){
          this.$router.push('/TheoryCourse/teachClass')
        }else if(this.productFlag==2){
          this.$router.push('/IndividualTraining/teachClass')
        }else if(this.productFlag==3){
          this.$router.push('/PracticalTraining/teachClass')
        }else if(this.productFlag==4){
          this.$router.push('/RealTask/teachClass')
        }else{
          this.$router.go(-1);
        }
        
        console.log(this.$store.state.activeIndex);
			},
			handleClick(tab, event) {
        this.$store.state.showBack = true;
        this.$store.state.activeName = tab.name;
     	}
		}
	}
</script>

<style lang="scss" scoped>
	.course_wrap {
		padding: 16px;
		padding-bottom: 0;
		.course_admin {
			padding: 16px;
			background: #fff;
			header {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				margin-bottom: 36px;
				i {
					width:4px;
					height:12px;
					background:rgba(83,151,247,1);
					margin-right: 10px;
				}
				.goback {
					display: flex;
					align-items: center;
					cursor: pointer;
					img {
						display: inline-block;
						width: 18px;
						height: 18px;
					}
					span {
						font-size: 14px;
						padding: 0 8px;
						color: #858C96;
					}
				}
				span {
					font-size: 16px;
					color: #0D141E;
				}
			}
			.tabs {
				position: relative;
				/deep/ .el-tabs__active-bar {
					height: 4px;
					left: -33px;
				}
				/deep/ .el-tabs__item {
					padding: 0 38px;
				}
				/deep/ .el-tabs__active-bar {
					width: 120px !important;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/TeachClass/courseAdmin.vue